export enum DateRangeType {
    LAST_SIX_MONTHS="Last 6 Months"
}

export interface DateRange {
    from?: Date;
    to?: Date;
}

const SECOND_MS:number = 60 * 1000;
const MINUTE_MS:number = 60 * SECOND_MS;
const HOUR_MS:number = 60 * MINUTE_MS;
const DAY_MS:number = 24 * HOUR_MS;
const WEEK_MS:number = 7 * DAY_MS;
const MONTH_MS:number = 30 * DAY_MS;
const YEAR_MS:number = 365 * DAY_MS;

export const getDateRange = (type:DateRangeType):DateRange=>
{
    let range:DateRange = {};
    let now = new Date();
    switch(type)
    {
        
        case DateRangeType.LAST_SIX_MONTHS:
        default:
            range = {
                from: new Date(now.getTime() - (6 * MONTH_MS)),
                to: now
            };
            break;
    }
    return range;

}

export const isSameMonth = (d1:Date, d2:Date):boolean => {
    return d1.getUTCMonth() == d2.getUTCMonth() && d1.getUTCFullYear() == d2.getUTCFullYear()
}